import React from "react";
import Modal from "components/base/Modal";
import css from "./style.scss";
import { downloadContactsWithNoNumber } from "../../data/property";
import { useDispatch } from "react-redux";

const PhoneNumberUnavailable = ({
    isOpen,
    onClose,
    totalAttempted,
    unavailableCount,
    preflightResponse,
    showToastMessage
}) => {

    const dispatch = useDispatch();

    const handleDownloadCSV = () => {
        const skipTraced = preflightResponse?.contactsMissingPhoneNumberSkipTraced || [];

        const payload = {
            fileNamePrefix: 'UnresolvedAfterSkipTrace',
            contactIds: skipTraced
        }

        dispatch(downloadContactsWithNoNumber(
            payload,
            () => {
                onClose();
            },
            () => {
                showToastMessage("error", "Something went wrong. Please try again.");
            }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            isCloseButton={false}
            uniqId="phone-numbers-unavailable"
            borderRadius="12px"
            modalClassName={css.phoneUnavailableModal}
        >
            <div className={css.modalContainer}>
                <span className={css.headertxt}>Phone Numbers Unavailable</span>
                <span className={css.contenttxt}>
                    We attempted to skip trace{" "}
                    <span className={css.boldNumber}>{totalAttempted}</span>{" "}
                    {totalAttempted === 1 ? "property" : "properties"}.{" "}
                    <span className={css.boldNumber}>{unavailableCount}</span>{" "}
                    {unavailableCount === 1 ? "property" : "properties"}{" "}
                    still have no phone numbers available.
                </span>
                <div className={css.buttonWrapper}>
                    <button className={css.cancelBtn} onClick={onClose}>
                        <span className={css.cancelBtnLabel}>Cancel</span>
                    </button>
                    <button className={css.downloadBtn} onClick={handleDownloadCSV}>
                        <span className={css.downloadBtnLabel}>Download CSV</span>
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PhoneNumberUnavailable;